module.exports = __webpack_public_path__ + "static/media/019-woman-5.18af8fe5.svg";